import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { isPresent } from '@mode/shared/util-js';
import {
  ReportDbtMetadataDomainState,
  getReportDbtMetadataLoading,
  getReportDbtMetadata,
  getIsComplete,
} from './report-dbt-metadata/report-dbt-metadata.selectors';
import { filter } from 'rxjs/operators';
import { ReportTypes } from '@mode/shared/contract-common';
import * as ReportDbtMetadataActions from './report-dbt-metadata/report-dbt-metadata.actions';

@Injectable({
  providedIn: 'root',
})
export class ReportDbtMetadataFacade {
  constructor(private store: Store<ReportDbtMetadataDomainState>) {
    this.reportDbtMetadata$ = store.select(getReportDbtMetadata).pipe(filter(isPresent));
    this.reportDbtMetadataComplete$ = store.select(getIsComplete);
    this.reportDbtMetadataLoading$ = store.select(getReportDbtMetadataLoading).pipe(filter(isPresent));
  }

  readonly reportDbtMetadata$: Observable<ReportTypes.ReportDbtMetaData>;
  readonly reportDbtMetadataLoading$: Observable<boolean>;
  readonly reportDbtMetadataComplete$: Observable<boolean>;

  loadReportDbtMetadata(accountId: string, reportToken: string) {
    this.store.dispatch(
      ReportDbtMetadataActions.loadReportDbtMetadata({
        accountId,
        reportToken,
      })
    );
  }
}
